import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import './guideList.css';

// Utility: always coerce to string before trimming/formatting
const cleanName = (name) => {
  const s = name == null ? '' : String(name); // <-- key fix
  return s
    .trim()                      // Remove leading and trailing spaces
    .replace(/\r|\n/g, '')       // Remove newline characters
    .replace(/\s{2,}/g, ' ')     // Replace multiple spaces with a single space
    .toLowerCase()               // Convert to lowercase
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Title case
};

const GuideList = () => {
  const reviews = useSelector((state) => state.reviews.reviews);
  const { search } = useLocation();

  const [searchQuery, setSearchQuery] = useState(''); // State for search input

  // Extract unique guide names and their statistics
  const guideStats = reviews.reduce((acc, review, idx) => {
    if (!review || review.length < 11) {
      // Optional debug for malformed rows
      // console.warn('[GuideList] row missing K column at index', idx, review);
      return acc;
    }

    const rawGuideName = review[10];
    if (rawGuideName != null && typeof rawGuideName !== 'string') {
      // Log once per odd type to help diagnose sheet typing issues
      console.warn('[GuideList] Non-string guide name in column K:', rawGuideName, 'typeof=', typeof rawGuideName);
    }

    const guideName = cleanName(rawGuideName);
    if (
      !guideName ||
      guideName === '?' ||
      guideName === 'Cancelled' ||
      guideName === 'Cancelled (No Guide)' ||
      guideName === 'Cancelled Tour' ||
      guideName === 'N/D' ||
      guideName === 'Na' ||
      guideName === 'No Guide'
    ) {
      return acc;
    }

    if (!acc[guideName]) {
      acc[guideName] = {
        totalReviews: 0,
        totalRating: 0,
      };
    }

    acc[guideName].totalReviews += 1;

    // Be safe: rating might come as string/number
    const rating = Number(review[4]);
    if (Number.isFinite(rating)) {
      acc[guideName].totalRating += rating;
    } else {
      // Optional: log unexpected rating types
      // console.warn('[GuideList] Non-numeric rating at column 5:', review[4], 'row index:', idx);
    }

    return acc;
  }, {});

  const guides = Object.keys(guideStats).map((name) => {
    const { totalReviews, totalRating } = guideStats[name];
    return {
      name,
      averageRating: totalReviews > 0 ? (totalRating / totalReviews).toFixed(2) : '0.00',
      totalReviews,
    };
  });

  // Sort guides alphabetically by name
  guides.sort((a, b) => a.name.localeCompare(b.name));

  // Filter guides based on the search query
  const filteredGuides = guides.filter(
    (guide) => guide.name.toLowerCase().startsWith(searchQuery.toLowerCase()) && guide.name !== '?'
  );

  return (
    <div className="guide-list">
      <h2>Guide List</h2>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search guides..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-bar"
        />
      </div>

      <div className="guide-list-container">
        {filteredGuides.map((guide) => (
          <Link
            key={guide.name}
            to={{ pathname: `/guides/${encodeURIComponent(guide.name)}`, search }}
            className="guide-item"
          >
            <div className="guide-name">{guide.name}</div>
            <div className="guide-stats">
              ({guide.totalReviews} reviews)
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default GuideList;
